import { render, staticRenderFns } from "./PanelCompetitionForm.vue?vue&type=template&id=b045b5a2&scoped=true&"
import script from "./PanelCompetitionForm.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionForm.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionForm.vue?vue&type=style&index=0&id=b045b5a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b045b5a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b045b5a2')) {
      api.createRecord('b045b5a2', component.options)
    } else {
      api.reload('b045b5a2', component.options)
    }
    module.hot.accept("./PanelCompetitionForm.vue?vue&type=template&id=b045b5a2&scoped=true&", function () {
      api.rerender('b045b5a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelCompetitionForm.vue"
export default component.exports